import { StyledAppModal } from './AppModal.styled';
import { useAudio } from '../../providers/AudioContext';
import { useEffect } from 'react';

const AppModal = ({ children, dark = false, sound = 'popup' }) => {
  const { playSFX } = useAudio();
  useEffect(() => playSFX(sound), []);

  return (
    <StyledAppModal $dark={dark}>
      <div className='app-modal-content' onClick={(e) => e.stopPropagation()}>
        {children}
        <div className='app-modal-corner app-modal-corner-tl' />
        <div className='app-modal-corner app-modal-corner-tr' />
        <div className='app-modal-corner app-modal-corner-bl' />
        <div className='app-modal-corner app-modal-corner-br' />
      </div>
    </StyledAppModal>
  );
};

export default AppModal;
